import React, { useState, Fragment, useContext } from "react";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { Dialog, DialogTitle, DialogBackdrop, Transition } from "@headlessui/react";
import {useClassNames} from '../../hooks/useClassNames';
import { MetaforceContext } from "../../contexts"
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../translations/translationsConstants";

export default function GenericSidebar({ open, setOpen, onClose, title, subTitle, children, width }) {
    const classNames = useClassNames();
    const { themeAndStyle } = useContext(MetaforceContext);
    const { t: te } = useTranslation([resources.edit]);

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="tw-fixed tw-inset-0 tw-max-w-full tw-overflow-hidden tw-z-50"
                open={open}
                onClose={onClose}
            >
                <div className="tw-absolute tw-inset-0 tw-max-w-full tw-overflow-hidden">
                    <DialogBackdrop className="tw-absolute tw-inset-0 tw-max-w-full" />

                    <div className="tw-fixed tw-inset-y-0 tw-right-0 tw-max-w-full tw-flex">
                        <Transition.Child
                            as={Fragment}
                            enter="tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700"
                            enterFrom="tw-translate-x-full"
                            enterTo="tw-translate-x-0"
                            leave="tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700"
                            leaveFrom="tw-translate-x-0"
                            leaveTo="tw-translate-x-full"
                        >
                            <div className={
                                classNames.classNames(
                                    width ? width : 'tw-max-w-lg',
                                    'tw-w-screen '
                                )}>
                                <div className="tw-h-full tw-flex tw-flex-col tw-bg-white tw-shadow-xl tw-overflow-y-scroll">
                                    <div className="tw-flex-shrink-0">
                                        {/* Header */}
                                        <div className="tw-px-4 tw-py-6 tw-bg-indigo-700 sm:tw-px-6">
                                            <div className="tw-flex tw-items-start tw-justify-between tw-space-x-3">
                                                <div className="tw-space-y-1">
                                                    <DialogTitle className="tw-text-lg tw-font-medium tw-text-white">
                                                        {title}
                                                    </DialogTitle>
                                                    {subTitle}
                                                </div>
                                                <div className="tw-h-7 tw-flex tw-items-center">
                                                    <button
                                                        type="button"
                                                        className="tw-border-none tw-bg-indigo-700 tw-rounded-md tw-text-white hover:tw-bg-indigo-800 tw-cursor-pointer"
                                                        onClick={() => setOpen(false)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault();
                                                                setOpen(false);
                                                            }
                                                        }}
                                                    >
                                                        <span className="tw-sr-only">{te(translations.edit.closePanel)}</span>
                                                        <XMarkIcon className="tw-h-6 tw-w-6" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {children}
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
